<span *ngIf="intlNumberOpts$ | async; let intlNumberOpts" itemprop="priceSpecification" itemscope itemtype="http://schema.org/PriceSpecification">
  {{ price | intlNumber: intlNumberOpts }}
</span>
